import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild } from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { AdvanceVectoringUserService } from "app/analytic/advance-vectoring-user.service";
import { AdvanceVectoringLoaderService } from "app/analytic/advance-vectoring-loader.service";
import * as moment from "moment";
import { debounceTime, distinctUntilChanged, Subject, Subscription } from "rxjs";
import * as FileSaver from "file-saver";
import { map } from "underscore";
import { ActivatedRoute, Router } from "@angular/router";
import { ApiService } from "app/modules/shared/services/api.service";
import { CryptoService } from "app/shared/utils/crypto.service";

@Component({
  selector: "app-adavance-vectoring-users",
  templateUrl: "./adavance-vectoring-users.component.html",
  styleUrls: ["./adavance-vectoring-users.component.scss"],
})
export class AdavanceVectoringUsersComponent implements OnInit, OnDestroy {
  //  ***************SG-4637 start  *******************

  dateInfo: any;
  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  dateType: { type: string; from: string; to: string; count: number };
  displayedColumns: string[] = ["title", "sessionsPlayed", "clearedSessionCount", "failedCount", "separationViolation", "percentageCompleteMission"];
  dataSource: MatTableDataSource<any>;

  startDate: any;
  endDate: any;
  subSink: Subscription;
  @Input() dateData$: any;
  @Input() selectedApp: any;
  gameData: any;
  missionRecords: any;
  pageSize: number;
  userName: any;

  constructor(private advanceVectoringService: AdvanceVectoringUserService, private route: ActivatedRoute, private router: Router, private api: ApiService, private crypto: CryptoService, public avLoader: AdvanceVectoringLoaderService) {}

  ngOnInit(): void {
    this.userName = localStorage.getItem("nickName");
    let missionData = localStorage.getItem("selectedApp");
    this.gameData = JSON.parse(missionData);
    if (JSON.parse(missionData).title == "Advanced Vectoring") {
      this.dateInfo = JSON.parse(localStorage.getItem("dateRange"));
      this.subSink = this.dateData$.pipe(debounceTime(500), distinctUntilChanged()).subscribe((next) => {
        if (next) {
          if (this.dateInfo) {
            next = this.dateInfo;
          }
          this.dateType = { type: "", from: "", to: "", count: 0 };
          this.dateType.type = next.type ? next.type.toLowerCase() : "day";
          this.dateType.from = next.from ? next.from : moment(new Date()).format("YYYY-MM-DD");
          this.dateType.to = next.to ? next.to : moment(new Date()).subtract(30, "days");
          this.dateType.count = next.count ? next.count : 30;
          this.startDate = moment(next.startDate).format("YYYY-MM-DD");
          this.endDate = moment(next.endDate).format("YYYY-MM-DD");
          this.getUserMissionData();
        }
      });
    }
  }

  async getUserMissionData() {
    let nameStr = this.crypto.isProbablyEncrypted(this.userName) ? this.userName : await this.crypto.encryptData(this.userName);

    this.avLoader.set("table", true);
    this.advanceVectoringService
      .getUserMissionData(this.gameData.id, this.dateType.type, this.startDate, this.endDate, nameStr)
      .pipe(debounceTime(500), distinctUntilChanged())
      .subscribe((response: any) => {
        this.avLoader.set("table", false);
        this.missionRecords = response;
        // this.dataSource = new MatTableDataSource<any>(this.missionRecords);
        this.dataSource = new MatTableDataSource(response);
        this.dataSource.sort = this.sort;
        this.pageSize = 5;
        this.dataSource.paginator = this.paginator;
        this.dateInfo = undefined;
      });
  }
  ngOnDestroy(): void {
    if (this.subSink) this.subSink.unsubscribe();
    this.avLoader.set("table", false);
  }

  onPageChange(event) {}

  exportCsvData(usage) {
    this.advanceVectoringService.downloadMissiondata(this.dateType.type, this.gameData.id, this.userName).subscribe((data: any) => {
      let dataObject: any = data;
      if (data.type === "application/zip") {
        var blob = new Blob([data], { type: data.type });
        FileSaver.saveAs(blob, usage.toUpperCase() + ".zip");
      } else {
        var blob = new Blob([data], { type: "application/csv" });
        FileSaver.saveAs(blob, usage.toUpperCase() + ".csv");
      }
    });
  }

  // ***************SG-7049 start  *******************

  missionLevelData(mission) {
    this.api.addRoute(0, mission.title, mission.id);
    let missionData = localStorage.getItem("selectedApp");
    let selectedApp = JSON.parse(missionData);
    let appData = { ...selectedApp, missionType: mission.missionType };
    localStorage.setItem("selectedApp", JSON.stringify(appData));
    this.api.showDateSelector = false;
    this.router.navigate(["main/user/details/advance", this.userName, mission.title]);
  }
  // ***************SG-7049 end  *******************
}
//  ***************SG-4637 end  *******************
